module.exports = __webpack_public_path__ + "img/cyb.cee0f974.png";